import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import SEOMeta from '@/components/base/SEOMeta';
import StructuredData from '@/components/base/StructuredData';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const hotArticles = articles.filter((a) => a.isHot);
  const latestArticles = articles.sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料大全',
    url: 'https://heiliao.com',
    description: '全网热门黑料汇总平台，涵盖娱乐圈、网红、明星等各类爆料信息，持续更新。',
    logo: 'https://heiliao.com/logo.png',
    sameAs: ['https://weibo.com/heiliao', 'https://twitter.com/heiliao'],
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料大全',
    url: 'https://heiliao.com',
    description: '黑料大全收录全网最新、最全的热门黑料内容，涵盖娱乐圈、网红、明星等各类爆料信息，持续更新，助你第一时间掌握热点黑料动态。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliao.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOMeta
        title="黑料大全 - 全网热门黑料汇总平台"
        description="黑料大全收录全网最新、最全的热门黑料内容，涵盖娱乐圈、网红、明星等各类爆料信息，持续更新，助你第一时间掌握热点黑料动态，是吃瓜群众的必备参考平台。"
        keywords="黑料大全,明星黑料大全,娱乐圈黑料大全,网红黑料汇总,最新黑料爆料,热门黑料合集,吃瓜黑料平台"
        canonicalUrl="https://heiliao.com"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20gossip%20news%20website%20homepage%20with%20dramatic%20red%20headlines%20and%20celebrity%20scandal%20theme%2C%20bold%20typography%2C%20news%20media%20aesthetic&width=1200&height=630&seq=home-og&orientation=landscape"
        ogImageAlt="黑料大全首页"
      />
      <StructuredData data={orgSchema} />
      <StructuredData data={webSiteSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full">
            <div className="relative h-[500px] md:h-[620px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20red%20and%20black%20abstract%20background%20with%20fiery%20glowing%20particles%2C%20news%20headlines%20silhouettes%2C%20breaking%20news%20aesthetic%2C%20intense%20atmosphere%2C%20bold%20dramatic%20composition%2C%20tabloid%20media%20vibe&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
                alt="黑料大全 - 全网热门黑料汇总"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
            </div>
            <div className="absolute inset-0 flex items-center">
              <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
                <div className="max-w-3xl">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500">
                      <i className="ri-fire-fill text-background-50 text-xl"></i>
                    </span>
                    <span className="text-sm font-medium text-primary-300 bg-primary-900/50 px-3 py-1.5 rounded-full whitespace-nowrap">
                      实时更新中
                    </span>
                  </div>
                  <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight font-heading">
                    全网热门
                    <span className="text-primary-400">黑料</span>
                    汇总平台
                  </h1>
                  <p className="text-base md:text-lg text-white/70 mb-8 leading-relaxed max-w-xl">
                    收录全网最新、最全的热门黑料内容，涵盖娱乐圈、网红、明星等各类爆料信息，持续更新，助你第一时间掌握热点黑料动态。
                  </p>
                  <div className="flex items-center gap-3 flex-wrap">
                    <Link
                      to={`/article/${hotArticles[0]?.id || articles[0].id}`}
                      className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
                    >
                      查看最新爆料
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                    <Link
                      to="/about"
                      className="px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-lg font-medium text-sm hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      了解更多
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Category Quick Nav */}
          <section className="w-full bg-background-100 border-b border-background-200/70">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-5">
              <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide flex-wrap">
                <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  热门分类：
                </span>
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200/70 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className={`${cat.icon} text-base`}></i>
                    {cat.name}
                  </Link>
                ))}
                <Link
                  to="/about"
                  className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200/70 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-information-line text-base"></i>
                  关于我们
                </Link>
              </div>
            </div>
          </section>

          {/* Featured Hot Article */}
          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                今日热门爆料
              </h2>
            </div>
            <ArticleCard article={hotArticles[0] || articles[0]} variant="featured" />
          </section>

          {/* Hot Articles Grid */}
          <section className="w-full bg-background-100 py-10 md:py-14">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                    <i className="ri-flashlight-fill text-background-50 text-lg"></i>
                  </span>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                    热门黑料
                  </h2>
                </div>
                <Link
                  to="/category/yulequan"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
                {hotArticles.slice(0, 6).map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500">
                <i className="ri-time-line text-background-50 text-lg"></i>
              </span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                最新爆料
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          {/* Trending Tags */}
          <section className="w-full bg-background-100 py-10 md:py-14">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center gap-3 mb-6">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
                  <i className="ri-hashtag text-background-50 text-lg"></i>
                </span>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                  热门标签
                </h2>
              </div>
              <div className="flex flex-wrap gap-3">
                {[
                  '假货', '直播翻车', '恋情曝光', '学历造假',
                  '耍大牌', '假赛', '税务问题', '财务造假',
                  '抄袭', '霸凌', '食品安全', '聊天记录',
                ].map((tag) => (
                  <span
                    key={tag}
                    className="px-4 py-2 rounded-full bg-background-50 border border-background-200/70 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-600">
                <i className="ri-question-answer-line text-background-50 text-lg"></i>
              </span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
                常见问题
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                {
                  q: '黑料大全的内容来源是什么？',
                  a: '我们汇聚全网各大社交平台、新闻媒体及网友投稿的爆料内容，经过整理和验证后呈现给用户，确保信息的丰富性和时效性。',
                },
                {
                  q: '平台上的黑料信息是否真实可靠？',
                  a: '我们致力于提供真实可靠的信息，所有内容均标注来源。对于无法核实的信息，我们会特别标注"待证实"，建议用户理性看待。',
                },
                {
                  q: '如何订阅最新黑料推送？',
                  a: '您可以收藏本站或关注我们的社交媒体账号，我们会第一时间推送最新最热的黑料内容。目前暂不支持邮件订阅。',
                },
                {
                  q: '如果发现不实信息怎么办？',
                  a: '如您发现平台上有不实信息或侵权内容，请通过"关于我们"页面的联系方式与我们取得联系，我们将在24小时内核实处理。',
                },
              ].map((faq, i) => (
                <div
                  key={i}
                  className="p-5 rounded-xl bg-background-100 border border-background-200/70"
                >
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                    {faq.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              ))}
            </div>

            <StructuredData
              data={{
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: '黑料大全的内容来源是什么？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '我们汇聚全网各大社交平台、新闻媒体及网友投稿的爆料内容，经过整理和验证后呈现给用户，确保信息的丰富性和时效性。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '平台上的黑料信息是否真实可靠？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '我们致力于提供真实可靠的信息，所有内容均标注来源。对于无法核实的信息，我们会特别标注"待证实"，建议用户理性看待。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '如何订阅最新黑料推送？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '您可以收藏本站或关注我们的社交媒体账号，我们会第一时间推送最新最热的黑料内容。目前暂不支持邮件订阅。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '如果发现不实信息怎么办？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '如您发现平台上有不实信息或侵权内容，请通过"关于我们"页面的联系方式与我们取得联系，我们将在24小时内核实处理。',
                    },
                  },
                ],
              }}
            />
          </section>

          {/* CTA */}
          <section className="w-full bg-secondary-900 py-14 md:py-20">
            <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4 font-heading">
                第一时间掌握热点黑料动态
              </h2>
              <p className="text-secondary-300 mb-8 text-sm md:text-base leading-relaxed">
                黑料大全持续追踪全网最新爆料，关注我们，不再错过任何一个"惊天大瓜"
              </p>
              <Link
                to={`/article/${hotArticles[0]?.id || articles[0].id}`}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-fill"></i>
                立即吃瓜
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}